// src/components/organization/OrganizationList.tsx
import React from 'react';
import {
    OrganizationList as ClerkOrganizationList,
    SignOutButton,
    useOrganizationList,
} from '@clerk/clerk-react';
import { clerkSignInUpElements, clerkVariables } from '../variables/clerk';

const OrganizationList = () => {
    const { userMemberships, userInvitations } = useOrganizationList({
        userMemberships: { infinite: true },
        userInvitations: { infinite: true },
    });

    return (
        <div className="auth-container">
            {userMemberships.isLoading == false &&
                userInvitations.isLoading == false &&
                userMemberships.data &&
                userInvitations.data && (
                    <>
                        {userMemberships.data.length > 0 ||
                        userInvitations.data.length > 0 ? (
                            <ClerkOrganizationList
                                hidePersonal={true}
                                afterSelectOrganizationUrl={(org) =>
                                    `/orgs/${org.slug}`
                                }
                                appearance={{
                                    elements: clerkSignInUpElements,
                                    variables: clerkVariables,
                                }}
                            />
                        ) : (
                            <div className="clerk-card">
                                <h1 className="clerk-card-title">
                                    No Organisation Access
                                </h1>
                                <p className="clerk-card-text">
                                    You are not currently a member of any
                                    country organisation on the app.
                                </p>
                                <p className="clerk-card-text">
                                    If you require access, please reach out to:
                                </p>
                                <ul className="clerk-card-contact-list">
                                    <li>
                                        <a href="mailto:annemie.bressinck@ab-inbev.com">
                                            Annemie Bressinck
                                        </a>{' '}
                                        for Netherlands, BeLux, or France
                                    </li>
                                    <li>
                                        <a href="mailto:andrii.pavlyshynets@abinbevefes.com.ua">
                                            Andrii Pavlyshynets
                                        </a>{' '}
                                        for all other countries
                                    </li>
                                </ul>
                                <SignOutButton>
                                    <button className="clerk-card-button">
                                        Sign Out
                                    </button>
                                </SignOutButton>
                            </div>
                        )}
                    </>
                )}
        </div>
    );
};

export default OrganizationList;
